<template>
  <v-container>
    <v-row class="">
      <v-col cols="12" class="mt-1  font-weight-black">


        Facebook Option


      </v-col>
      <v-col cols="12" sm="12" md="3" lg="3">
  
        <v-card @click="goVideope()" class="rounded-xl mx-auto mt-0 " style="">
          <v-card-title class="red darken-0 white--text font-weight-black " style="font-size: 14px;">


            <!-- <v-img aspect-ratio="3.075" max-height="40" :src="require('@/assets/fb.png/')" position="left" contain /> -->
            <!-- <v-spacer></v-spacer>
            PreView -->
            <v-spacer></v-spacer>
            <v-icon color="white">
              mdi-eye
            </v-icon>
          </v-card-title>
          <v-card-text class='pb-10'>
            <v-row>
              <v-col cols='12'>
                <v-subheader class="grey--text text--lighten-1 pl-0 subheader">Premium</v-subheader>
                <h3 style="" >
                   Video PE
                </h3>
                <br />
                <!-- <v-btn block>
                  Login
                </v-btn> -->
              </v-col>

            </v-row>
          </v-card-text>


        </v-card>


      </v-col>
      <v-col cols="12" sm="12" md="3" lg="3">
        <v-card class="rounded-xl mx-auto mt-0 ">
          <v-card-title class="red darken-0 white--text font-weight-black " style="font-size: 14px;">


            <!-- <v-img aspect-ratio="3.075" max-height="40" :src="require('@/assets/fb.png/')" position="left" contain /> -->
            <v-spacer></v-spacer>
            <v-icon color="white">
              mdi-eye
            </v-icon>
            
          </v-card-title>
          <v-card-text class='pb-10'>
            <v-row>
              <v-col cols='12'>
                <v-subheader class="grey--text text--lighten-1 pl-0 subheader">Premium ( Comming Soon )</v-subheader>
                <h3>
                   Image PE
                </h3>
                <br />
                <!-- <v-btn block>
                  Login
                </v-btn> -->
              </v-col>

            </v-row>
          </v-card-text>


        </v-card>


      </v-col>
      <v-col cols="12" sm="12" md="3" lg="3">
        <v-card class="rounded-xl mx-auto mt-0 ">
          <v-card-title class="red darken-0 white--text font-weight-black " style="font-size: 14px;">


            <!-- <v-img aspect-ratio="3.075" max-height="40" :src="require('@/assets/fb.png/')" position="left" contain /> -->
            <v-spacer></v-spacer>
            <v-icon color="white">
              mdi-eye
            </v-icon>
          </v-card-title>
          <v-card-text class='pb-10'>
            <v-row>
              <v-col cols='12'>
                <v-subheader class="grey--text text--lighten-1 pl-0 subheader">Premium (Comming Soon)</v-subheader>
                <h3>
                   Share to Group
                </h3>
                <br />
                <!-- <v-btn block>
                  Login
                </v-btn> -->
              </v-col>

            </v-row>
          </v-card-text>


        </v-card>


      </v-col>
      <v-col cols="12" sm="12" md="3" lg="3">
        <v-card class="rounded-xl mx-auto mt-0 ">
          <v-card-title class="red darken-0 white--text font-weight-black " style="font-size: 14px;">


            <!-- <v-img aspect-ratio="3.075" max-height="40" :src="require('@/assets/fb.png/')" position="left" contain /> -->
            <v-spacer></v-spacer>
            <v-icon color="white">
              mdi-eye
            </v-icon>
          </v-card-title>
          <v-card-text class='pb-10'>
            <v-row>
              <v-col cols='12'>
                <v-subheader class="grey--text text--lighten-1 pl-0 subheader">Premium</v-subheader>
                <h3>
                  Comming Soon
                </h3>
                <br />
                <!-- <v-btn block>
                  Login
                </v-btn> -->
              </v-col>

            </v-row>
          </v-card-text>


        </v-card>


      </v-col>



    </v-row>
    <v-row class="">
      <v-col cols="12" class="mt-1  font-weight-black">


        TikTok Comming Soon


      </v-col>

    </v-row>
    <v-dialog v-model="dialog" persistent max-width="290">

      <v-card>
        <v-card-title class="text-h5">

          Facebook Login
        </v-card-title>

        <v-card-text>
          Please go to login facebook first !
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="loginFacebook()">
            Login Facebook
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogExtention" persistent max-width="290">

      <v-card>
        <v-card-title class="text-h5">

          Install Extension
        </v-card-title>

        <v-card-text>
          Please go to Install Chrome Extensions Cam-Tool
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="installextension()">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
  </v-container>
</template>
<script>
import axios from 'axios'

export default {
  name: 'HelloWorld',

  data: () => ({
    overlay:false,
    URL_IMAGE: './src/assets/fb.png',
    isLogin: '',
    myResult: [],
    fbUserName: '',
    fbUserID: '',
    dialog: false,
    dialogExtention: false
  }),

  methods: {

    goVideope() {

      this.$router.push('fb-videope')
    },
    goFbshare() {
      this.$router.push('fb-share')
    },
    goToCreatePage() {
      this.$router.push('fb-create-page')
    },
    goToClone() {
      this.$router.push('fb-clone')
    },
    loginFacebook() {
      window.location.href = "https://m.facebook.com"
    },
    installextension(){
      // window.location.reload()
      this.dialogExtention = false
    }
  },
  mounted() {
    // if (this.isLogin == true) {

    //   this.$swal('Facebook Login', 'Please login  facebook', 'error');

    // }
    // this.isLogin = JSON.parse(localStorage.getItem("isLogin"));
    // axios.get('https://m.facebook.com/composer/ocelot/async_loader/?publisher=feed').then((data) => {

    //   var trim_string = data.data.split('CurrentUserInitialData');
    //   var data_text = trim_string[1].split('\",[],')[1]
    //   data_text = data_text.split('SHORT_NAME')
    //   var json_text = data_text[0] + '}'
    //   this.myResult = json_text.split(',').map(s => s.trim());
    //   var userName = this.myResult[2].split('NAME')[1]
    //   var id = this.myResult[1].split('USER_ID')[1]
    //   this.fbUserID = id.replace(/[^a-zA-Z0-9]/g, "")
    //   this.fbUserName = userName.replace(/[^a-zA-Z ]/g, "")
    //   this.dialogExtention = false

    //   if (this.fbUserName != '') {



    //     this.dialog = false

    //     $.ajax({
    //       url: "https://www.facebook.com/adsmanager/manage/campaigns",
    //       type: "get",
    //       success: function (t) {
    //         if (-1 != t.search("EAA")) {
    //           var o = t.match(/EAAB.*?\"/),
    //             n = o[0] ? o[0].replace(/\W/g, "") : "";
    //           console.log(e(n))
    //         } else {
    //           var url_re = t.split("window.location.replace")
    //           var last_url = url_re[1].split('script')[0].replace('("', "").replace('");</', "").split('campaigns?')

    //           $.ajax({
    //             url: "https://www.facebook.com/adsmanager/manage/campaigns?".concat(last_url[1], "&nav_source=no_referrer"),
    //             type: "get",
    //             success: function (t) {
    //               if (-1 == t.search("EAA")) return e("");
    //               var o = t.match(/EAAB.*?\"/),
    //                 n = o[0] ? o[0].replace(/\W/g, "") : "";
    //               var s = t.split('DTSGInitialData')[1].split('\",[],')[1].replace(',258],["ISB', "")
    //               var j_text = JSON.parse(s)
    //               localStorage.setItem("dsg", j_text.token)
    //               localStorage.setItem("accessToken", n)


    //             }
    //           })

    //         }

    //       }
    //     })


    //   } else {

    //     this.dialog = false

    //   }



    // }).catch((data) => {


    //   this.dialogExtention = false

    // })
    var $t = this;
    $t.overlay=true;
    var token = localStorage.getItem('accessToken');
    // console.log(token);
    if(token == null) token =1;
    $.ajax({
      url:"https://graph.facebook.com/me",
      data:{
        access_token:token
      }
    }).then(function(data){

    
      var hasPropertyError = Object.prototype.hasOwnProperty.call(data, "error");
      if(hasPropertyError)
      {

        $.ajax({
              url: "https://www.facebook.com/adsmanager/manage/campaigns",
              type: "get",
              success: function (t) {
                if (-1 != t.search("EAA")) {
                  var o = t.match(/EAAB.*?\"/),
                    n = o[0] ? o[0].replace(/\W/g, "") : "";
                  console.log(e(n))
                } else {
                  var url_re = t.split("window.location.replace")
            
                  var last_url = url_re[1].split('script')[0].replace('("', "").replace('");</', "").split('campaigns?')
                  // console.log(last_url);
                  $.ajax({
                    url: "https://www.facebook.com/adsmanager/manage/campaigns?".concat(last_url[1], "&nav_source=no_referrer"),
                    type: "get",
                    success: function (t) {
                  
                      if (-1 == t.search("EAA")) return e("");
                      var o = t.match(/EAAB.*?\"/),
                        n = o[0] ? o[0].replace(/\W/g, "") : "";
                      localStorage.setItem("accessToken", n)
                      $t.overlay=false;

                    }
                  })

                }

              }
            }).catch((data) => {


              $t.dialogExtention = true
              $t.overlay=false;

            })


      }else{
        $t.overlay=false;
      }

    }).fail(function(){


      $.ajax({
              url: "https://www.facebook.com/adsmanager/manage/campaigns",
              type: "get",
              success: function (t) {
                if (-1 != t.search("EAA")) {
                  var o = t.match(/EAAB.*?\"/),
                    n = o[0] ? o[0].replace(/\W/g, "") : "";
                  console.log(e(n))
                } else {
                  var url_re = t.split("window.location.replace")
            
                  var last_url = url_re[1].split('script')[0].replace('("', "").replace('");</', "").split('campaigns?')
                  // console.log(last_url);
                  $.ajax({
                    url: "https://www.facebook.com/adsmanager/manage/campaigns?".concat(last_url[1], "&nav_source=no_referrer"),
                    type: "get",
                    success: function (t) {
                  
                      if (-1 == t.search("EAA")) return e("");
                      var o = t.match(/EAAB.*?\"/),
                        n = o[0] ? o[0].replace(/\W/g, "") : "";
                      localStorage.setItem("accessToken", n)
                      $t.overlay=false;

                    }
                  })

                }

              }
            }).catch((data) => {


              $t.dialogExtention = true
              $t.overlay=false;

            })
            


    })

    // $.ajax({
    //       url: "https://www.facebook.com/adsmanager/manage/campaigns",
    //       type: "get",
    //       success: function (t) {
    //         if (-1 != t.search("EAA")) {
    //           var o = t.match(/EAAB.*?\"/),
    //             n = o[0] ? o[0].replace(/\W/g, "") : "";
    //           console.log(e(n))
    //         } else {
    //           var url_re = t.split("window.location.replace")
        
    //           var last_url = url_re[1].split('script')[0].replace('("', "").replace('");</', "").split('campaigns?')
    //           // console.log(last_url);
    //           $.ajax({
    //             url: "https://www.facebook.com/adsmanager/manage/campaigns?".concat(last_url[1], "&nav_source=no_referrer"),
    //             type: "get",
    //             success: function (t) {
               
    //               if (-1 == t.search("EAA")) return e("");
    //               var o = t.match(/EAAB.*?\"/),
    //                 n = o[0] ? o[0].replace(/\W/g, "") : "";
    //               localStorage.setItem("accessToken", n)
    //               $t.overlay=false;

    //             }
    //           })

    //         }

    //       }
    //     }).catch((data) => {


    //       this.dialogExtention = true
    //       $t.overlay=false;

    //     })

  },
  computed: {
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 220
        case 'sm': return 400
        case 'md': return 500
        case 'lg': return 600
        case 'xl': return 800
      }
    },
  },
  created() {


   


  }


}
</script>
